module.exports = __webpack_public_path__ + "static/media/jorge.9aabc14a.webp";